(function iefe(w, d) {
    const nav = d.querySelector('.MainNav__expandable');
    const subbuttons = d.querySelectorAll('.MainNav__button');
    const lastchilds = d.querySelectorAll(
        '.MainSubnav__list > .MainSubnav__item:last-child .MainSubnav__link, '
        + '.MainSubnav__list > .SecondSubnav:last-child .MainSubnav__item:last-child .MainSubnav__link'
    );
    const logos = d.querySelectorAll('.Header__homelink .Icon, .FooterNav__homelink .Icon');

    logos.forEach((logo) => {
        logo.removeAttribute('aria-hidden');
    });

    if (nav) {
        const navButton = d.querySelector('.Header__button');
        if (navButton) {
            navButton.addEventListener('click', () => {
                const exp = navButton.getAttribute('aria-expanded') === 'false';
                navButton.setAttribute('aria-expanded', exp ? 'true' : 'false');
                nav.classList[exp ? 'add' : 'remove']('MainNav__expandable--active');
            });
        }
    }

    if (subbuttons) {
        subbuttons.forEach((button) => {
            button.addEventListener('click', () => {
                const exp = button.getAttribute('aria-expanded') === 'false';
                const current = d.querySelector('.MainNav__button[aria-expanded = true]');
                if (current) {
                    current.setAttribute('aria-expanded', 'false');
                }
                button.setAttribute('aria-expanded', exp ? 'true' : 'false');
            });
        });
    }

    /* close Menu if tabbed outside */
    if (lastchilds) {
        lastchilds.forEach((item) => {
            item.addEventListener('keydown', (e) => {
                const zInd = w.getComputedStyle(document.querySelector('html')).zIndex;
                if (e.code === 'Tab' && !e.shiftKey && zInd >= '200') {
                    const active = d.querySelector('.MainNav__button[aria-expanded = true]');
                    if (active) {
                        active.setAttribute('aria-expanded', 'false');
                    }
                }
            });
        });
    }

    /* close Menu if clicked outside */
    w.addEventListener('click', (e) => {
        const current = document.querySelector('.MainNav__button[aria-expanded = true]');
        const zInd = w.getComputedStyle(document.querySelector('html')).zIndex;
        if (current && zInd >= '200') {
            const parent = current.parentElement;
            if (parent) {
                if (!parent.contains(e.target)) {
                    current.setAttribute('aria-expanded', 'false');
                }
            }
        }
    });
}(window, document));
